<template>
  <div class="wrapper">
    <a name="pagetop" id="pagetop" class="sr">ページの先頭</a>
    <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
        _/                                                                                                                    _/
        _/      税理士事務所共通ヘッダ                                                                                          _/
        _/                                                                                                                    _/
    _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/-->
    <HeaderNav menuflg="4" />
    <div class="body">
      <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
           _/                                                                                                                    _/
           _/      画面定義                                                                                                      _/
           _/                                                                                                                    _/
           _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/ -->
      <div class="body">
        <div class="inner">
          <div class="pankuzu">
            <ul>
              <li>
                <router-link class="ico-home" :to="{ name: 'STFMFM01C01' }"
                  >メインページ</router-link
                >
              </li>
              <li>
                <span class="current">セキュリティ管理</span>
              </li>
            </ul>
          </div>
          <h1 class="h1">セキュリティ管理</h1>
          <!-- ****  メッセージ表示領域 **** -->
          <!-- ****  メッセージ表示領域 **** -->
          <div class="frm-row">
            <div class="frm-item grow left">
              <p
                class="errMsg title-ico ico-warning"
                v-show="errors.length > 0"
              >
                <ErrorMessage :errors="errors"></ErrorMessage>
              </p>
            </div>
          </div>
        </div>
        <div class="content-body">
          <div class="inner">
            <nav class="content-nav">
              <ul>
                <li
                  v-for="(tab, index) in routeArray"
                  :key="tab.routeName"
                  :class="
                    $route.name.includes(tab.routeName) ||
                    $route.name.includes(tab.subRouteName)
                      ? `current ` + 'menu' + (index + 1)
                      : 'menu' + (index + 1)
                  "
                >
                  <!--tab.class ＝＞ 選択ボタンイメージがまだないです -->
                  <router-link :to="{ name: tab.routeName }"
                    ><p v-html="tab.name"></p
                  ></router-link>
                </li>
              </ul>
            </nav>
            <div class="content">
              <router-view></router-view>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import Common from "@/util/common.js";
import HeaderNav from "@/components/AccountingHeader.vue";
import { API_GetSubPageID } from "@/api/Modules/DC05/STDSDC05C01";
import ErrorMessage from "@/components/ErrorMessage.vue";
import { useRouter, onBeforeRouteUpdate, useRoute } from "vue-router";
import { onMounted, computed, ref } from "vue";
import { useStore } from "vuex";
import router from "@/router";
const errorsList = ref([]);
const store = useStore();
const { push } = useRouter();
const { name: routeName } = useRoute();
const routeArray = [
  {
    name: "アカウント<br>管理",
    routeName: "STDSDC05C02",
    subRouteName: "STDSDC05C03",
  },
  {
    name: "機能利用<br>権限",
    routeName: "STDSDC05C05",
    subRouteName: "STDSDC05C06",
  },
  {
    name: "ログインセ<br>キュリティ",
    routeName: "STDSDC05C07",
  },
  { name: "ログイン<br>履歴", routeName: "STDSDC05C08" },
  { name: "操作履歴", routeName: "STDSDC05C09" },
];
const toPage = (routeName) => {
  push({
    name: `${routeName}`,
  });
};

const getSubpageID = () => {
  API_GetSubPageID().then(async (response) => {
    if (response.result == "0000") {
      if (response.subPageID) {
        toPage(response.subPageID);
      } else {
        toPage("STDSDC05C02");
      }
    } else {
      // エラー表示
      errorsList.value.push(
        Common.createError(
          response.errorCD,
          Common.getMessage(response.errorCD, [])
        )
      );
      console.log(errorsList);
    }
  });
};

onMounted(() => {
  // エラーメッセージを初期化
  store.commit("securityModule/updateErrors", []);
  // 遷移先は「05C01：セキュリティ管理」の場合、前回の遷移画面表示
  if (routeName === "STDSDC05C01") {
    getSubpageID();
  }
});

// タブ切替動作
onBeforeRouteUpdate((to, from) => {
  // エラーメッセージを初期化
  store.commit("securityModule/updateErrors", []);
});

const errors = computed(() => {
  const subErrorList = store.getters["securityModule/getErrorStatus"]
    ? store.getters["securityModule/getErrors"]
    : [];
  return [...subErrorList, ...errorsList.value];
});
</script>
